<template>
  <div class="login">
    <h1>苏医在线系统登录</h1>
    <div style="text-align:center; width:100%">
    <el-form ref="form" :model="form" :rules="rules"  >
      <el-form-item label="用户名"  style="position:relative; left:22%">
        <el-col :span="10">
          <el-input v-model="form.username" maxlength="30" placeholder="请输入用户名" ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="密   码"  style="position:relative; left:23%">
        <el-col :span="10">
          <el-input type="password"  v-model="form.password" maxlength="30" placeholder="请输入密码"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item style="position:relative; left:42%; width:100px">
        <el-button type="primary" @click="onSubmit('form')">登录</el-button>
      </el-form-item>
    </el-form>
    </div>
  </div>
</template>



<script>
import qs from "qs";
export default {
  name: "Login",
  data() {
    return {
      loginApi: "http://121.196.220.228:30002/login",
      form: {
        username: "",
        password:""
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 3, max: 30, message: "长度在 7 到 15 个字符", trigger: "blur" }
        ],

        password : [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 3, max: 30, message: "长度在 7 到 15 个字符", trigger: "blur" }
        ]
      }
    };
  },
  props: {
    msg: String
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        let _this = this;

        if (valid) {
          if (_this.form.username.trim() == "") {
            alert("请输入用户名");
          } else if(_this.form.password.trim() == ""){
            alert("请输入密码");
          }else
          {
            let datas = {
              account: _this.form.username + "",
              password: _this.form.password + ""
              };
            //console.log(datas);
            _this.axios
              .post(_this.loginApi, qs.stringify(datas))
              .then(response => {
                let res = response.data;
                //console.log(res);
                if (res.data.token!=null && res.data.token.trim()!=""&&res.data.role!=null) {
                    if(res.data.role==2){
                      sessionStorage.setItem("authToken",res.data.token.substring(7) );
                      _this.$router.replace("/SignCheck");
                    }
                    else {
                      alert("用户名或密码错误，请使用前台的用户名密码登录！");
                    }
                 } else {
              
                    alert("用户名或密码错误，请重新登录");
                  
                }
              }).catch((e) => { alert(e+",用户名或密码错误，请重新登录");});
          }
        } else {
          alert("提交出错");
          return false;
        }
      });
    }
  },
  mounted() {}
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  text-align: center;
  padding-top: 100px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
